<template>
    <auth-box class="max-w-[480px]">
        <div v-if="error" class="flex flex-col gap-1 pt-10 text-center">
            <font-awesome-icon widthAuto :icon="faTriangleExclamation" class="text-rose-500" size="2x"></font-awesome-icon>
            <div class="text-xl font-extrabold">
                Error
            </div>
            <div class="text-sm text-slate-500">
                {{ error }}
            </div>
            <div class="pt-8">
                <vx-button block color="muted" size="lg" href="/login">
                    Log In Options <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
                </vx-button>
            </div>
        </div>
        <form v-else @submit.prevent="checkWorkspace()"
            class="flex flex-col gap-4">

            <div>
                <vx-label for="workspace_slug">
                    Workspace
                </vx-label>
                <vx-input required type="text" v-model="workspaceSlug" autofocus name="workspace_slug" id="workspace_slug" size="lg"></vx-input>
            </div>

            <div class="flex flex-col gap-2 mt-4 md:flex-row-reverse">
                <vx-button :loading="submitting" class="md:grow" type="submit" color="primary" size="lg">
                   Continue <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
                </vx-button>

                <vx-button color="muted" size="lg" href="/login">
                    Cancel
                </vx-button>
            </div>
        </form>
    </auth-box>
</template>
<script setup>
import AuthBox from '../../AuthBox.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxLabel, VxInput, VxButton } from '@voxie/frontend-components';
import { faArrowRight, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { ref } from 'vue';
import axios from '~/services/axios';

const props = defineProps({
    errorMessage: String
})

const workspaceSlug = ref('');
const submitting = ref(false);

const error = ref(props.errorMessage);

const checkWorkspace = async () => {
    try {
        const response = await axios.get(`/sso/saml2/${encodeURIComponent(workspaceSlug.value)}/redirect`)

        if (response?.data?.redirect_url) {
            window.location.href = response.data.redirect_url;
        } else {
            error.value = 'An error occurred when trying to lookup your workspace.';
        }
    } catch {
        error.value = 'An error occurred when trying to lookup your workspace.';
    } finally {
        submitting.value = false;
    }

}
</script>
